<template>
  <div>
    <b-container fluid class="content courier">
      <b-alert
        :show="countdown"
        dismissible
        variant="success"
        @dismissed="countdown = 0"
        @dismiss-count-down="close_alert"
        class="show_alert"
      >
        {{ dismessage }}
      </b-alert>
      <b-row class="mt-4">
        <b-col>
          <b-card>
            <b-row class="m-3 p-2 border bg-secondary">
              <b-col>
                {{ $t('Name') }}
                <el-input
                  :label="$t('Name')"
                  class="p-0 m-0"
                  size="mini"
                  v-model="InputName" />
              </b-col>
              <b-col cols="7" v-if="showTrackingUrl">
                {{ $t('Tracking URL') }}
                <el-input
                  :label="$t('Tracking URL')"
                  class="p-0 m-0"
                  size="mini"
                  v-model="InputTrackingUrl" />
              </b-col>
              <b-col>
                <el-button type="primary" class="mt-4" size="mini" @click="add_courier()" v-acl:CourierEdit.enable.show>{{ $t('Add') }}</el-button>
              </b-col>
            </b-row>
            <p class="p-3">
              <el-table
                stripe
                class="table-responsive table"
                header-row-class-name="thead-light"
                :data="courierlist"
                row-key="IDn"
                style="width: 100%;"
              >
                <el-table-column :label="$t('Name')" prop="Name" :min-width="40">
                  <template slot-scope="scope">
                    <el-input
                      class="p-0 m-0"
                      size="mini"
                      v-model="scope.row.Name"
                      @change="update_courier(scope.row)"
                      v-acl:CourierEdit.enable
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column v-if="showTrackingUrl" :label="$t('Tracking URL')" prop="TrackingUrl" :min-width="100">
                  <template slot-scope="scope">
                    <el-input
                      class="p-0 m-0"
                      size="mini"
                      v-model="scope.row.TrackingUrl"
                      @change="update_courier(scope.row)"
                      v-acl:CourierEdit.enable
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Sort Order')" prop="SortOrder" :min-width="35">
                  <template slot-scope="scope">
                    <div class="courier-sort-order">
                      <span class="courier-sort-order__value">{{ scope.row.SortOrder }}</span>
                      <el-button
                        type="text"
                        size="mini"
                        class="courier-sort-order__button"
                        :disabled="scope.$index === 0 || sortOrderUpdating"
                        @click="move_courier_sort_order(scope.$index, -1)"
                        v-acl:CourierEdit.enable
                      >
                        <i class="el-icon-top"></i>
                      </el-button>
                      <el-button
                        type="text"
                        size="mini"
                        class="courier-sort-order__button"
                        :disabled="scope.$index === courierlist.length - 1 || sortOrderUpdating"
                        @click="move_courier_sort_order(scope.$index, 1)"
                        v-acl:CourierEdit.enable
                      >
                        <i class="el-icon-bottom"></i>
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Updated')" prop="UpdateDateTime" :min-width="45"></el-table-column>
                <el-table-column :min-width="20" v-if="hasUtilityAuth('CourierEdit')">
                  <template slot-scope="scope">
                    <div class="w-100 p-1 text-center title2" @click="remove_courier(scope.row.IDn)" v-acl:CourierEdit.enable.show>
                      <el-tooltip
                        effect="light"
                        content="Delete Courier"
                        placement="top"
                        style="margin: auto"
                        :openDelay="300"
                      >
                        <i class="ni ni-fat-remove icon-remove"></i>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </p>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { Table, TableColumn, Button, Row, Col } from "element-ui";
import { getStore } from "../../util/helper";
import { hasUtilityAuth } from "../../directives/acl";

const axios = require("axios");

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
  },
  data() {
    return {
      InputName: "",
      InputTrackingUrl: "",
      showTrackingUrl: false,
      courierlist: [],
      sortOrderUpdating: false,

      dismessage: "",
      countdown: 0,

      token: "",
      user_id: 0,
    };
  },
  methods: {
    hasUtilityAuth,
    close_alert(countDownChanged) {
      this.countdown = countDownChanged;
      if (this.countdown == 0) {
        this.dismessage = "";
      }
    },
    set_courierlist(couriers) {
      this.courierlist = [];
      this.$nextTick(() => {
        this.courierlist = couriers;
      });
    },
    get_next_sort_order() {
      var maxSortOrder = 0;
      this.courierlist.forEach(function (courier) {
        var sortOrder = parseInt(courier.SortOrder);
        if (!isNaN(sortOrder) && sortOrder > maxSortOrder) {
          maxSortOrder = sortOrder;
        }
      });
      return maxSortOrder + 1;
    },
    async remove_courier(IDn) {
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("opt", "delete");
      bodyFormData.append("IDn", IDn);

      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/courier/edit",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.set_courierlist(rt.data.couriers);
              that.dismessage = that.$t("Data Updated Successfully");
              that.countdown = 3;
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function () {
          that.$router.push("/login");
        });
    },
    async update_courier(row, refresh = true) {
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("opt", "update");
      bodyFormData.append("IDn", row.IDn);
      bodyFormData.append("Name", row.Name);
      bodyFormData.append("TrackingUrl", row.TrackingUrl);
      bodyFormData.append("SortOrder", row.SortOrder);

      var that = this;

      return axios({
        method: "post",
        url: "/Api/Web/courier/edit",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              if (refresh) {
                that.set_courierlist(rt.data.couriers);
              }
              return true;
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
          return false;
        })
        .catch(function () {
          that.$router.push("/login");
          return false;
        });
    },
    async move_courier_sort_order(index, direction) {
      if (this.sortOrderUpdating || !Array.isArray(this.courierlist)) {
        return;
      }

      var targetIndex = index + direction;
      if (targetIndex < 0 || targetIndex >= this.courierlist.length) {
        return;
      }

      var list = this.courierlist.slice();
      var current = list[index];
      var target = list[targetIndex];
      var sortOrder = current.SortOrder;

      current.SortOrder = target.SortOrder;
      target.SortOrder = sortOrder;
      list[index] = target;
      list[targetIndex] = current;
      this.courierlist = list;

      this.sortOrderUpdating = true;
      try {
        var currentUpdated = await this.update_courier(current, false);
        var targetUpdated = await this.update_courier(target, false);

        if (currentUpdated && targetUpdated) {
          this.dismessage = this.$t("Data Updated Successfully");
          this.countdown = 3;
        }
        return this.get_courier_list();
      } finally {
        this.sortOrderUpdating = false;
      }
    },
    async add_courier() {
      if (this.InputName.length < 1) {
        alert("Please input courier name");
        return;
      }

      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("opt", "add");
      bodyFormData.append("IDn", 0);
      bodyFormData.append("Name", this.InputName);
      bodyFormData.append("TrackingUrl", this.InputTrackingUrl);
      bodyFormData.append("SortOrder", this.get_next_sort_order());

      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/courier/edit",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.InputName = "";
              that.InputTrackingUrl = "";
              that.set_courierlist(rt.data.couriers);
              that.dismessage = that.$t("Data Updated Successfully");
              that.countdown = 3;
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function () {
          that.$router.push("/login");
        });
    },
    async get_courier_list() {
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/courier",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.set_courierlist(rt.data.couriers);
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          } else {
            that.$router.push("/login");
          }
        })
        .catch(function () {
          that.$router.push("/login");
        });
    },
    async init_data() {
      this.token = getStore("token");
      this.user_id = getStore("user_id");
      if (!this.token || !this.user_id) {
        this.$router.push("/login");
        return;
      }
      return this.get_courier_list();
    },
  },
  mounted() {
    this.init_data();
  },
};
</script>
<style>
.content {
  padding-top: 80px;
}
.courier .el-table tr td {
  padding-top: 0;
  padding-bottom: 0;
}
.icon-remove {
  color: #404040;
  background-color: rgba(255, 0, 0, 0.5);
  border-radius: 50%;
}
.courier-sort-order {
  align-items: center;
  display: flex;
  gap: 6px;
  justify-content: center;
}
.courier-sort-order__value {
  min-width: 32px;
  text-align: right;
}
.courier-sort-order__button {
  color: #409eff;
  margin-left: 0;
  padding: 4px;
}
</style>
